export const colors = {
    lightGrey: '#f1f1f1',
    darkGrey: '#283E4A',
    white: '#FFF',
    grey: "#777",
    blue: '#C5D9E9',
    greenGrey: '#757D75'
};